import ImportSourceConfigsTable from "./components/ImportSourceConfigsTable.jsx";

export default function ImportSourceConfigPage() {
  return <ImportSourceConfigsTable />;
}
